export function getCenterDate(v0?: Date, v1?: Date) {
  //Compatible with Area series
  const uniqueValue = v0 ?? v1;

  if (!uniqueValue) {
    throw new Error(
      'At least one date value must be provided for the one dimension axis.',
    );
  }

  return new Date(
    v0 && v1 ? (v0.getTime() + v1.getTime()) / 2 : uniqueValue.getTime(),
  );
}
